import { HttpClient } from "../common/http-client";
import { Environment } from "../environment/app-settings";
import { affiliateAlternativeOffertsNames } from '../pages/AffiliatePage/affiliatePartnersData'
import {PREDEFINED_PERIODS_OFFER_LOGIC, SliderStep} from "../store/types";

export interface ICalculateLoanParams { 
   instalments: number,
   requestedAmount: number,
}

export interface ILoanInitLimits {
  minInstalments: number;
  maxInstalments: number;
  minRequestedAmount: number;
  maxRequestedAmount: number;
  requestedAmountSteps: SliderStep[]
}

export interface ILoanInitCalculate{
  loanAmountNet: number;
  instalments: number;
  ckdz: number;
  rrso: number;
  interestRate: number;
  instalmentAmount: number;
}

export interface ILoanInitCreateApplicationParams {
  userEmail: string;
  amountToPay: number;
  instalmentNumber: number;
  alternativeOffertNameFromFront?: affiliateAlternativeOffertsNames; 
}

export interface IAffiliatePresetOffertParams {
  requestedAmount: number;
  instalments: number;
}

export interface ILoanInitCreateApplicationResponse {
  redirectUrl: string;
}

export interface IAffiliateStatisticRecordParams {
  partnerId: string;
  clientId: string | null;
  affiliateData: string;
  source: typeof LoanInitService.AFFILIATE_STATISTIC_FORM_PAGE_VALUE;
}

export interface ILeadStatisticRecordParams {
  alphaId: string | null;
  leadPartner: string;
  leadId: string;
  redirectionLink: string;
  clickId: string;
  eventType: LeadStatisticEventType;
}

export enum LeadStatisticEventType {
  "CLICK" = "CLICK",
  "AUTO" = "AUTO"
} 

export interface AffiliateStatisticRecordResponse {}
export interface LeadStatisticRecordResponse {}

export class LoanInitService {
  private readonly _client: HttpClient;
  private readonly _basedUrl = "loanInit";
  private readonly _limitsUrlPath = '/limits';
  private readonly _calculateUrlPath = '/calculate';
  private readonly _createApplicationUrlPath = '/createApp';
  private readonly _addAffiliateStatisticRecordUrlPath = '/addAffiliateStatistic';
  private readonly _addLeadStatisticRecordUrlPath = '/addLeadStatistic';
  public static AFFILIATE_STATISTIC_FORM_PAGE_VALUE: 'Development_Form' | 'Form' = process.env.NODE_ENV === 'development'?  'Development_Form' : 'Form'; //Wartość stała dla Formularza. 

  public readonly defaultInstalmentsNumber = 44;
  public readonly defaultRequestedAmount = 10000;
  public readonly defaultInstalmentsNumberForPredefinedPeriods = Environment.PREDEFINED_PERIODS_OFFER_LOGIC_INSTALMENT_MAP[PREDEFINED_PERIODS_OFFER_LOGIC.LONG_PERIOD];
  public readonly defaultRequestedAmountForPredefinedPeriods = 12500;
  private  requestedSteps: SliderStep[] = [
    {from: 0, value: 50},
    {from: 10000, value: 100},
    {from: 15000, value: 500}
  ]

  public readonly loanLimitsForDefaultOffert: ILoanInitLimits = {
    minInstalments: 42,
    maxInstalments: 48,
    minRequestedAmount: 2000,
    maxRequestedAmount: 30000,
    requestedAmountSteps: this.requestedSteps
  }

  constructor() {
    this._client = new HttpClient(Environment.apiUrl + this._basedUrl);
  }

  public async calculateLoanOffert(loanCalculateParams: ICalculateLoanParams, signal?: AbortSignal): Promise<ILoanInitCalculate> {
    return (await (this._client.post<ILoanInitCalculate, ICalculateLoanParams>(this._calculateUrlPath, loanCalculateParams, true, signal))).data;
  }

  public async getLoanLimits(): Promise<ILoanInitLimits> {
    return (await (this._client.post<ILoanInitLimits, {}>(this._limitsUrlPath, {}, true))).data;
  }

  public async createApplication(createApplicationParams: ILoanInitCreateApplicationParams): Promise<ILoanInitCreateApplicationResponse> {
    return (await (this._client.post<ILoanInitCreateApplicationResponse, ILoanInitCreateApplicationParams>(this._createApplicationUrlPath, createApplicationParams, true))).data;
  }

  public async addAffiliateStatisticRecord(affiliateStatisticRecordParams: IAffiliateStatisticRecordParams): Promise<void> {
    await (this._client.post<AffiliateStatisticRecordResponse, IAffiliateStatisticRecordParams>(this._addAffiliateStatisticRecordUrlPath, affiliateStatisticRecordParams, true))
  }

  public async addLeadStatisticRecord(leadStatisticRecordParams: ILeadStatisticRecordParams): Promise<void> {
    await (this._client.post<LeadStatisticRecordResponse, ILeadStatisticRecordParams>(this._addLeadStatisticRecordUrlPath, leadStatisticRecordParams, true))
  }
}


export default LoanInitService
export const loanInitService = new LoanInitService()